!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ScrollArea = t(require("react")) : e.ScrollArea = t(e.React);
}(this, function (e) {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        exports: {},
        id: o,
        loaded: !1
      };
      return e[o].call(r.exports, r, r.exports, t), r.loaded = !0, r.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.p = "", t(0);
  }([function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n(31);
    var r = n(13),
      i = o(r);
    t.default = i.default;
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(19)();
  }, function (e, t) {
    "use strict";

    function n(e) {
      var t = {};
      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = "number" == typeof e[n] ? e[n] : e[n].val);
      }
      return t;
    }
    t.__esModule = !0, t.default = n, e.exports = t.default;
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var n, o, r;
        "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : "undefined" != typeof t && null !== t && t.hrtime ? (e.exports = function () {
          return (n() - r) / 1e6;
        }, o = t.hrtime, n = function n() {
          var e;
          return e = o(), 1e9 * e[0] + e[1];
        }, r = n()) : Date.now ? (e.exports = function () {
          return Date.now() - r;
        }, r = Date.now()) : (e.exports = function () {
          return new Date().getTime() - r;
        }, r = new Date().getTime());
      }).call(this);
    }).call(t, n(10));
  }, function (e, t, n) {
    (function (t) {
      for (var o = n(23), r = "undefined" == typeof window ? t : window, i = ["moz", "webkit"], a = "AnimationFrame", l = r["request" + a], s = r["cancel" + a] || r["cancelRequest" + a], u = 0; !l && u < i.length; u++) {
        l = r[i[u] + "Request" + a], s = r[i[u] + "Cancel" + a] || r[i[u] + "CancelRequest" + a];
      }
      if (!l || !s) {
        var c = 0,
          f = 0,
          p = [],
          d = 1e3 / 60;
        l = function l(e) {
          if (0 === p.length) {
            var t = o(),
              n = Math.max(0, d - (t - c));
            c = n + t, setTimeout(function () {
              var e = p.slice(0);
              p.length = 0;
              for (var t = 0; t < e.length; t++) {
                if (!e[t].cancelled) try {
                  e[t].callback(c);
                } catch (e) {
                  setTimeout(function () {
                    throw e;
                  }, 0);
                }
              }
            }, Math.round(n));
          }
          return p.push({
            handle: ++f,
            callback: e,
            cancelled: !1
          }), f;
        }, s = function s(e) {
          for (var t = 0; t < p.length; t++) {
            p[t].handle === e && (p[t].cancelled = !0);
          }
        };
      }
      e.exports = function (e) {
        return l.call(r, e);
      }, e.exports.cancel = function () {
        s.apply(r, arguments);
      }, e.exports.polyfill = function (e) {
        e || (e = r), e.requestAnimationFrame = l, e.cancelAnimationFrame = s;
      };
    }).call(t, function () {
      return this;
    }());
  }, function (e, t) {
    "use strict";

    function n(e) {
      var t = {};
      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = 0);
      }
      return t;
    }
    t.__esModule = !0, t.default = n, e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function n(e, t, n) {
      for (var o in t) {
        if (Object.prototype.hasOwnProperty.call(t, o)) {
          if (0 !== n[o]) return !1;
          var r = "number" == typeof t[o] ? t[o] : t[o].val;
          if (e[o] !== r) return !1;
        }
      }
      return !0;
    }
    t.__esModule = !0, t.default = n, e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function n(e, t, n, r, i, a, l) {
      var s = -i * (t - r),
        u = -a * n,
        c = s + u,
        f = n + c * e,
        p = t + f * e;
      return Math.abs(f) < l && Math.abs(p - r) < l ? (o[0] = r, o[1] = 0, o) : (o[0] = p, o[1] = f, o);
    }
    t.__esModule = !0, t.default = n;
    var o = [0, 0];
    e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e) {
      return p ? f.default.findDOMNode(e) : e;
    }
    function i() {
      d || p || (d = !0, console.error("With React 0.14 and later versions, you no longer need to wrap <ScrollArea> child into a function."));
    }
    function a() {
      !d && p && (d = !0, console.error("With React 0.13, you need to wrap <ScrollArea> child into a function."));
    }
    function l(e) {
      return e < 0 ? 0 : e;
    }
    function s(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function (e) {
          return e;
        },
        n = {};
      for (var o in e) {
        e.hasOwnProperty(o) && (n[o] = t(e[o]));
      }
      return n;
    }
    function u(e) {
      var t = e.version;
      if ("string" != typeof t) return !0;
      var n = t.split("."),
        o = parseInt(n[0], 10),
        r = parseInt(n[1], 10);
      return 0 === o && 13 === r;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.findDOMNode = r, t.warnAboutFunctionChild = i, t.warnAboutElementChild = a, t.positiveOrZero = l, t.modifyObjValues = s, t.isReact13 = u;
    var c = n(1),
      f = o(c),
      p = u(f.default),
      d = !1;
  }, function (e, t) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }
    function o() {
      throw new Error("clearTimeout has not been defined");
    }
    function r(e) {
      if (c === setTimeout) return setTimeout(e, 0);
      if ((c === n || !c) && setTimeout) return c = setTimeout, setTimeout(e, 0);
      try {
        return c(e, 0);
      } catch (t) {
        try {
          return c.call(null, e, 0);
        } catch (t) {
          return c.call(this, e, 0);
        }
      }
    }
    function i(e) {
      if (f === clearTimeout) return clearTimeout(e);
      if ((f === o || !f) && clearTimeout) return f = clearTimeout, clearTimeout(e);
      try {
        return f(e);
      } catch (t) {
        try {
          return f.call(null, e);
        } catch (t) {
          return f.call(this, e);
        }
      }
    }
    function a() {
      y && d && (y = !1, d.length ? h = d.concat(h) : v = -1, h.length && l());
    }
    function l() {
      if (!y) {
        var e = r(a);
        y = !0;
        for (var t = h.length; t;) {
          for (d = h, h = []; ++v < t;) {
            d && d[v].run();
          }
          v = -1, t = h.length;
        }
        d = null, y = !1, i(e);
      }
    }
    function s(e, t) {
      this.fun = e, this.array = t;
    }
    function u() {}
    var c,
      f,
      p = e.exports = {};
    !function () {
      try {
        c = "function" == typeof setTimeout ? setTimeout : n;
      } catch (e) {
        c = n;
      }
      try {
        f = "function" == typeof clearTimeout ? clearTimeout : o;
      } catch (e) {
        f = o;
      }
    }();
    var d,
      h = [],
      y = !1,
      v = -1;
    p.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      h.push(new s(e, t)), 1 !== h.length || y || r(l);
    }, s.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = u, p.addListener = u, p.once = u, p.off = u, p.removeListener = u, p.removeAllListeners = u, p.emit = u, p.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, p.cwd = function () {
      return "/";
    }, p.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, p.umask = function () {
      return 0;
    };
  }, function (e, t) {
    "use strict";

    t.__esModule = !0, t.default = {
      noWobble: {
        stiffness: 170,
        damping: 26
      },
      gentle: {
        stiffness: 120,
        damping: 14
      },
      wobbly: {
        stiffness: 180,
        damping: 12
      },
      stiff: {
        stiffness: 210,
        damping: 20
      }
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e.default : e;
    }
    t.__esModule = !0;
    var r = n(24);
    t.Motion = o(r);
    var i = n(25);
    t.StaggeredMotion = o(i);
    var a = n(26);
    t.TransitionMotion = o(a);
    var l = n(29);
    t.spring = o(l);
    var s = n(11);
    t.presets = o(s);
    var u = n(3);
    t.stripStyle = o(u);
    var c = n(28);
    t.reorderKeys = o(c);
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
      s = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }
        return e;
      },
      u = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }
        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
      c = n(1),
      f = o(c),
      p = n(2),
      d = o(p),
      h = n(18),
      y = o(h),
      v = n(12),
      m = n(9),
      b = n(14),
      S = o(b),
      g = {
        wheel: "wheel",
        api: "api",
        touch: "touch",
        touchEnd: "touchEnd",
        mousemove: "mousemove",
        keyPress: "keypress"
      },
      w = function (e) {
        function t(e) {
          r(this, t);
          var n = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return n.state = {
            topPosition: 0,
            leftPosition: 0,
            realHeight: 0,
            containerHeight: 0,
            realWidth: 0,
            containerWidth: 0
          }, n.scrollArea = {
            refresh: function refresh() {
              n.setSizesToState();
            },
            scrollTop: function scrollTop() {
              n.scrollTop();
            },
            scrollBottom: function scrollBottom() {
              n.scrollBottom();
            },
            scrollYTo: function scrollYTo(e) {
              n.scrollYTo(e);
            },
            scrollLeft: function scrollLeft() {
              n.scrollLeft();
            },
            scrollRight: function scrollRight() {
              n.scrollRight();
            },
            scrollXTo: function scrollXTo(e) {
              n.scrollXTo(e);
            }
          }, n.evntsPreviousValues = {
            clientX: 0,
            clientY: 0,
            deltaX: 0,
            deltaY: 0
          }, n.bindedHandleWindowResize = n.handleWindowResize.bind(n), n.bindedHandleWheel = n.handleWheel.bind(n), n;
        }
        return a(t, e), u(t, [{
          key: "getChildContext",
          value: function value() {
            return {
              scrollArea: this.scrollArea
            };
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            this.props.contentWindow && this.props.contentWindow.addEventListener("resize", this.bindedHandleWindowResize), this.lineHeightPx = (0, y.default)((0, m.findDOMNode)(this.content)), this.setSizesToState(), this.wrapper.addEventListener("wheel", this.bindedHandleWheel, {
              passive: !1
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.props.contentWindow && this.props.contentWindow.removeEventListener("resize", this.bindedHandleWindowResize), this.wrapper.removeEventListener("wheel", this.bindedHandleWheel);
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.setSizesToState();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              n = t.children,
              o = t.className,
              r = t.contentClassName,
              i = t.ownerDocument,
              a = this.props.smoothScrolling && (this.state.eventType === g.wheel || this.state.eventType === g.api || this.state.eventType === g.touchEnd || this.state.eventType === g.keyPress),
              l = this.canScrollY() ? f.default.createElement(S.default, {
                ownerDocument: i,
                realSize: this.state.realHeight,
                containerSize: this.state.containerHeight,
                position: this.state.topPosition,
                onMove: this.handleScrollbarMove.bind(this),
                onPositionChange: this.handleScrollbarYPositionChange.bind(this),
                containerStyle: this.props.verticalContainerStyle,
                scrollbarStyle: this.props.verticalScrollbarStyle,
                smoothScrolling: a,
                minScrollSize: this.props.minScrollSize,
                onFocus: this.focusContent.bind(this),
                type: "vertical"
              }) : null,
              u = this.canScrollX() ? f.default.createElement(S.default, {
                ownerDocument: i,
                realSize: this.state.realWidth,
                containerSize: this.state.containerWidth,
                position: this.state.leftPosition,
                onMove: this.handleScrollbarMove.bind(this),
                onPositionChange: this.handleScrollbarXPositionChange.bind(this),
                containerStyle: this.props.horizontalContainerStyle,
                scrollbarStyle: this.props.horizontalScrollbarStyle,
                smoothScrolling: a,
                minScrollSize: this.props.minScrollSize,
                onFocus: this.focusContent.bind(this),
                type: "horizontal"
              }) : null;
            "function" == typeof n ? ((0, m.warnAboutFunctionChild)(), n = n()) : (0, m.warnAboutElementChild)();
            var c = "scrollarea " + (o || ""),
              p = "scrollarea-content " + (r || ""),
              d = {
                marginTop: -this.state.topPosition,
                marginLeft: -this.state.leftPosition
              },
              h = a ? (0, m.modifyObjValues)(d, function (e) {
                return (0, v.spring)(e);
              }) : d;
            return f.default.createElement(v.Motion, {
              style: h
            }, function (t) {
              return f.default.createElement("div", {
                ref: function ref(t) {
                  return e.wrapper = t;
                },
                className: c,
                style: e.props.style
              }, f.default.createElement("div", {
                ref: function ref(t) {
                  return e.content = t;
                },
                style: s({}, e.props.contentStyle, t),
                className: p,
                onTouchStart: e.handleTouchStart.bind(e),
                onTouchMove: e.handleTouchMove.bind(e),
                onTouchEnd: e.handleTouchEnd.bind(e),
                onKeyDown: e.handleKeyDown.bind(e),
                tabIndex: e.props.focusableTabIndex
              }, n), l, u);
            });
          }
        }, {
          key: "setStateFromEvent",
          value: function value(e, t) {
            this.props.onScroll && this.props.onScroll(e), this.setState(s({}, e, {
              eventType: t
            }));
          }
        }, {
          key: "handleTouchStart",
          value: function value(e) {
            var t = e.touches;
            if (1 === t.length) {
              var n = t[0],
                o = n.clientX,
                r = n.clientY;
              this.eventPreviousValues = s({}, this.eventPreviousValues, {
                clientY: r,
                clientX: o,
                timestamp: Date.now()
              });
            }
          }
        }, {
          key: "handleTouchMove",
          value: function value(e) {
            this.canScroll() && (e.preventDefault(), e.stopPropagation());
            var t = e.touches;
            if (1 === t.length) {
              var n = t[0],
                o = n.clientX,
                r = n.clientY,
                i = this.eventPreviousValues.clientY - r,
                a = this.eventPreviousValues.clientX - o;
              this.eventPreviousValues = s({}, this.eventPreviousValues, {
                deltaY: i,
                deltaX: a,
                clientY: r,
                clientX: o,
                timestamp: Date.now()
              }), this.setStateFromEvent(this.composeNewState(-a, -i));
            }
          }
        }, {
          key: "handleTouchEnd",
          value: function value(e) {
            var t = this.eventPreviousValues,
              n = t.deltaX,
              o = t.deltaY,
              r = t.timestamp;
            "undefined" == typeof n && (n = 0), "undefined" == typeof o && (o = 0), Date.now() - r < 200 && this.setStateFromEvent(this.composeNewState(10 * -n, 10 * -o), g.touchEnd), this.eventPreviousValues = s({}, this.eventPreviousValues, {
              deltaY: 0,
              deltaX: 0
            });
          }
        }, {
          key: "handleScrollbarMove",
          value: function value(e, t) {
            this.setStateFromEvent(this.composeNewState(t, e));
          }
        }, {
          key: "handleScrollbarXPositionChange",
          value: function value(e) {
            this.scrollXTo(e);
          }
        }, {
          key: "handleScrollbarYPositionChange",
          value: function value(e) {
            this.scrollYTo(e);
          }
        }, {
          key: "handleWheel",
          value: function value(e) {
            var t = e.deltaY,
              n = e.deltaX;
            if (this.props.swapWheelAxes) {
              var o = [n, t];
              t = o[0], n = o[1];
            }
            1 === e.deltaMode && (t *= this.lineHeightPx, n *= this.lineHeightPx), t *= this.props.speed, n *= this.props.speed;
            var r = this.composeNewState(-n, -t);
            (r.topPosition && this.state.topPosition !== r.topPosition || r.leftPosition && this.state.leftPosition !== r.leftPosition || this.props.stopScrollPropagation) && (e.preventDefault(), e.stopPropagation()), this.setStateFromEvent(r, g.wheel), this.focusContent();
          }
        }, {
          key: "handleKeyDown",
          value: function value(e) {
            if ("input" !== e.target.tagName.toLowerCase() && "textarea" !== e.target.tagName.toLowerCase() && !e.target.isContentEditable) {
              var t = 0,
                n = 0,
                o = this.lineHeightPx ? this.lineHeightPx : 10;
              switch (e.keyCode) {
                case 33:
                  t = this.state.containerHeight - o;
                  break;
                case 34:
                  t = -this.state.containerHeight + o;
                  break;
                case 37:
                  n = o;
                  break;
                case 38:
                  t = o;
                  break;
                case 39:
                  n = -o;
                  break;
                case 40:
                  t = -o;
              }
              if (0 !== t || 0 !== n) {
                var r = this.composeNewState(n, t);
                e.preventDefault(), e.stopPropagation(), this.setStateFromEvent(r, g.keyPress);
              }
            }
          }
        }, {
          key: "handleWindowResize",
          value: function value() {
            var e = this.computeSizes();
            e = this.getModifiedPositionsIfNeeded(e), this.setStateFromEvent(e);
          }
        }, {
          key: "composeNewState",
          value: function value(e, t) {
            var n = this.computeSizes();
            return this.canScrollY(n) ? n.topPosition = this.computeTopPosition(t, n) : n.topPosition = 0, this.canScrollX(n) && (n.leftPosition = this.computeLeftPosition(e, n)), n;
          }
        }, {
          key: "computeTopPosition",
          value: function value(e, t) {
            var n = this.state.topPosition - e;
            return this.normalizeTopPosition(n, t);
          }
        }, {
          key: "computeLeftPosition",
          value: function value(e, t) {
            var n = this.state.leftPosition - e;
            return this.normalizeLeftPosition(n, t);
          }
        }, {
          key: "normalizeTopPosition",
          value: function value(e, t) {
            return e > t.realHeight - t.containerHeight && (e = t.realHeight - t.containerHeight), e < 0 && (e = 0), e;
          }
        }, {
          key: "normalizeLeftPosition",
          value: function value(e, t) {
            return e > t.realWidth - t.containerWidth ? e = t.realWidth - t.containerWidth : e < 0 && (e = 0), e;
          }
        }, {
          key: "computeSizes",
          value: function value() {
            var e = this.content.offsetHeight,
              t = this.wrapper.offsetHeight,
              n = this.content.offsetWidth,
              o = this.wrapper.offsetWidth;
            return {
              realHeight: e,
              containerHeight: t,
              realWidth: n,
              containerWidth: o
            };
          }
        }, {
          key: "setSizesToState",
          value: function value() {
            var e = this.computeSizes();
            e.realHeight === this.state.realHeight && e.realWidth === this.state.realWidth || this.setStateFromEvent(this.getModifiedPositionsIfNeeded(e));
          }
        }, {
          key: "scrollTop",
          value: function value() {
            this.scrollYTo(0);
          }
        }, {
          key: "scrollBottom",
          value: function value() {
            this.scrollYTo(this.state.realHeight - this.state.containerHeight);
          }
        }, {
          key: "scrollLeft",
          value: function value() {
            this.scrollXTo(0);
          }
        }, {
          key: "scrollRight",
          value: function value() {
            this.scrollXTo(this.state.realWidth - this.state.containerWidth);
          }
        }, {
          key: "scrollYTo",
          value: function value(e) {
            if (this.canScrollY()) {
              var t = this.normalizeTopPosition(e, this.computeSizes());
              this.setStateFromEvent({
                topPosition: t
              }, g.api);
            }
          }
        }, {
          key: "scrollXTo",
          value: function value(e) {
            if (this.canScrollX()) {
              var t = this.normalizeLeftPosition(e, this.computeSizes());
              this.setStateFromEvent({
                leftPosition: t
              }, g.api);
            }
          }
        }, {
          key: "canScrollY",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state,
              t = e.realHeight > e.containerHeight;
            return t && this.props.vertical;
          }
        }, {
          key: "canScrollX",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state,
              t = e.realWidth > e.containerWidth;
            return t && this.props.horizontal;
          }
        }, {
          key: "canScroll",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state;
            return this.canScrollY(e) || this.canScrollX(e);
          }
        }, {
          key: "getModifiedPositionsIfNeeded",
          value: function value(e) {
            var t = e.realHeight - e.containerHeight;
            this.state.topPosition >= t && (e.topPosition = this.canScrollY(e) ? (0, m.positiveOrZero)(t) : 0);
            var n = e.realWidth - e.containerWidth;
            return this.state.leftPosition >= n && (e.leftPosition = this.canScrollX(e) ? (0, m.positiveOrZero)(n) : 0), e;
          }
        }, {
          key: "focusContent",
          value: function value() {
            this.content && (0, m.findDOMNode)(this.content).focus();
          }
        }]), t;
      }(f.default.Component);
    t.default = w, w.childContextTypes = {
      scrollArea: d.default.object
    }, w.propTypes = {
      className: d.default.string,
      style: d.default.object,
      speed: d.default.number,
      contentClassName: d.default.string,
      contentStyle: d.default.object,
      vertical: d.default.bool,
      verticalContainerStyle: d.default.object,
      verticalScrollbarStyle: d.default.object,
      horizontal: d.default.bool,
      horizontalContainerStyle: d.default.object,
      horizontalScrollbarStyle: d.default.object,
      onScroll: d.default.func,
      contentWindow: d.default.any,
      ownerDocument: d.default.any,
      smoothScrolling: d.default.bool,
      minScrollSize: d.default.number,
      swapWheelAxes: d.default.bool,
      stopScrollPropagation: d.default.bool,
      focusableTabIndex: d.default.number
    }, w.defaultProps = {
      speed: 1,
      vertical: !0,
      horizontal: !0,
      smoothScrolling: !1,
      swapWheelAxes: !1,
      contentWindow: "object" === ("undefined" == typeof window ? "undefined" : l(window)) ? window : void 0,
      ownerDocument: "object" === ("undefined" == typeof document ? "undefined" : l(document)) ? document : void 0,
      focusableTabIndex: 1
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }
        return e;
      },
      s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }
        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
      u = n(1),
      c = o(u),
      f = n(2),
      p = o(f),
      d = n(12),
      h = n(9),
      y = function (e) {
        function t(e) {
          r(this, t);
          var n = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
            o = n.calculateState(e);
          return n.state = {
            position: o.position,
            scrollSize: o.scrollSize,
            isDragging: !1,
            lastClientPosition: 0
          }, "vertical" === e.type ? n.bindedHandleMouseMove = n.handleMouseMoveForVertical.bind(n) : n.bindedHandleMouseMove = n.handleMouseMoveForHorizontal.bind(n), n.bindedHandleMouseUp = n.handleMouseUp.bind(n), n;
        }
        return a(t, e), s(t, [{
          key: "componentDidMount",
          value: function value() {
            this.props.ownerDocument && (this.props.ownerDocument.addEventListener("mousemove", this.bindedHandleMouseMove), this.props.ownerDocument.addEventListener("mouseup", this.bindedHandleMouseUp));
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            this.setState(this.calculateState(e));
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.props.ownerDocument && (this.props.ownerDocument.removeEventListener("mousemove", this.bindedHandleMouseMove), this.props.ownerDocument.removeEventListener("mouseup", this.bindedHandleMouseUp));
          }
        }, {
          key: "calculateFractionalPosition",
          value: function value(e, t, n) {
            var o = e - t;
            return 1 - (o - n) / o;
          }
        }, {
          key: "calculateState",
          value: function value(e) {
            var t = this.calculateFractionalPosition(e.realSize, e.containerSize, e.position),
              n = e.containerSize * e.containerSize / e.realSize,
              o = n < e.minScrollSize ? e.minScrollSize : n,
              r = (e.containerSize - o) * t;
            return {
              scrollSize: o,
              position: Math.round(r)
            };
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              n = t.smoothScrolling,
              o = t.isDragging,
              r = t.type,
              i = t.scrollbarStyle,
              a = t.containerStyle,
              s = "horizontal" === r,
              u = "vertical" === r,
              f = this.createScrollStyles(),
              p = n ? (0, h.modifyObjValues)(f, function (e) {
                return (0, d.spring)(e);
              }) : f,
              y = "scrollbar-container " + (o ? "active" : "") + " " + (s ? "horizontal" : "") + " " + (u ? "vertical" : "");
            return c.default.createElement(d.Motion, {
              style: p
            }, function (t) {
              return c.default.createElement("div", {
                className: y,
                style: a,
                onMouseDown: e.handleScrollBarContainerClick.bind(e),
                ref: function ref(t) {
                  return e.scrollbarContainer = t;
                }
              }, c.default.createElement("div", {
                className: "scrollbar",
                style: l({}, i, t),
                onMouseDown: e.handleMouseDown.bind(e)
              }));
            });
          }
        }, {
          key: "handleScrollBarContainerClick",
          value: function value(e) {
            e.preventDefault();
            var t = this.computeMultiplier(),
              n = this.isVertical() ? e.clientY : e.clientX,
              o = this.scrollbarContainer.getBoundingClientRect(),
              r = o.top,
              i = o.left,
              a = this.isVertical() ? r : i,
              l = n - a,
              s = this.props.containerSize * this.props.containerSize / this.props.realSize;
            this.setState({
              isDragging: !0,
              lastClientPosition: n
            }), this.props.onPositionChange((l - s / 2) / t);
          }
        }, {
          key: "handleMouseMoveForHorizontal",
          value: function value(e) {
            var t = this.computeMultiplier();
            if (this.state.isDragging) {
              e.preventDefault();
              var n = this.state.lastClientPosition - e.clientX;
              this.setState({
                lastClientPosition: e.clientX
              }), this.props.onMove(0, n / t);
            }
          }
        }, {
          key: "handleMouseMoveForVertical",
          value: function value(e) {
            var t = this.computeMultiplier();
            if (this.state.isDragging) {
              e.preventDefault();
              var n = this.state.lastClientPosition - e.clientY;
              this.setState({
                lastClientPosition: e.clientY
              }), this.props.onMove(n / t, 0);
            }
          }
        }, {
          key: "handleMouseDown",
          value: function value(e) {
            e.preventDefault(), e.stopPropagation();
            var t = this.isVertical() ? e.clientY : e.clientX;
            this.setState({
              isDragging: !0,
              lastClientPosition: t
            }), this.props.onFocus();
          }
        }, {
          key: "handleMouseUp",
          value: function value(e) {
            this.state.isDragging && (e.preventDefault(), this.setState({
              isDragging: !1
            }));
          }
        }, {
          key: "createScrollStyles",
          value: function value() {
            return "vertical" === this.props.type ? {
              height: this.state.scrollSize,
              marginTop: this.state.position
            } : {
              width: this.state.scrollSize,
              marginLeft: this.state.position
            };
          }
        }, {
          key: "computeMultiplier",
          value: function value() {
            return this.props.containerSize / this.props.realSize;
          }
        }, {
          key: "isVertical",
          value: function value() {
            return "vertical" === this.props.type;
          }
        }]), t;
      }(c.default.Component);
    y.propTypes = {
      onMove: p.default.func,
      onPositionChange: p.default.func,
      onFocus: p.default.func,
      realSize: p.default.number,
      containerSize: p.default.number,
      position: p.default.number,
      containerStyle: p.default.object,
      scrollbarStyle: p.default.object,
      type: p.default.oneOf(["vertical", "horizontal"]),
      ownerDocument: p.default.any,
      smoothScrolling: p.default.bool,
      minScrollSize: p.default.number
    }, y.defaultProps = {
      type: "vertical",
      smoothScrolling: !1
    }, t.default = y;
  }, function (e, t) {
    var n = function n(e, t, _n) {
      return _n = window.getComputedStyle, (_n ? _n(e) : e.currentStyle)[t.replace(/-(\w)/gi, function (e, t) {
        return t.toUpperCase();
      })];
    };
    e.exports = n;
  }, function (e, t, n) {
    t = e.exports = n(17)(), t.push([e.id, ".scrollarea-content{margin:0;padding:0;overflow:hidden;position:relative;touch-action:none}.scrollarea-content:focus{outline:0}.scrollarea{position:relative;overflow:hidden}.scrollarea .scrollbar-container{position:absolute;background:none;opacity:.1;z-index:99;-webkit-transition:all .4s;transition:all .4s}.scrollarea .scrollbar-container.horizontal{width:100%;height:10px;left:0;bottom:0}.scrollarea .scrollbar-container.horizontal .scrollbar{width:20px;height:8px;background:#000;margin-top:1px}.scrollarea .scrollbar-container.vertical{width:10px;height:100%;right:0;top:0}.scrollarea .scrollbar-container.vertical .scrollbar{width:8px;height:20px;background:#000;margin-left:1px}.scrollarea .scrollbar-container.active,.scrollarea .scrollbar-container:hover{background:gray;opacity:.6!important}.scrollarea:hover .scrollbar-container{opacity:.3}", ""]);
  }, function (e, t) {
    e.exports = function () {
      var e = [];
      return e.toString = function () {
        for (var e = [], t = 0; t < this.length; t++) {
          var n = this[t];
          n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1]);
        }
        return e.join("");
      }, e.i = function (t, n) {
        "string" == typeof t && (t = [[null, t, ""]]);
        for (var o = {}, r = 0; r < this.length; r++) {
          var i = this[r][0];
          "number" == typeof i && (o[i] = !0);
        }
        for (r = 0; r < t.length; r++) {
          var a = t[r];
          "number" == typeof a[0] && o[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a));
        }
      }, e;
    };
  }, function (e, t, n) {
    function o(e) {
      var t = r(e, "line-height"),
        n = parseFloat(t, 10);
      if (t === n + "") {
        var o = e.style.lineHeight;
        e.style.lineHeight = t + "em", t = r(e, "line-height"), n = parseFloat(t, 10), o ? e.style.lineHeight = o : delete e.style.lineHeight;
      }
      if (t.indexOf("pt") !== -1 ? (n *= 4, n /= 3) : t.indexOf("mm") !== -1 ? (n *= 96, n /= 25.4) : t.indexOf("cm") !== -1 ? (n *= 96, n /= 2.54) : t.indexOf("in") !== -1 ? n *= 96 : t.indexOf("pc") !== -1 && (n *= 16), n = Math.round(n), "normal" === t) {
        var i = e.nodeName,
          a = document.createElement(i);
        a.innerHTML = "&nbsp;";
        var l = r(e, "font-size");
        a.style.fontSize = l;
        var s = document.body;
        s.appendChild(a);
        var u = a.offsetHeight;
        n = u, s.removeChild(a);
      }
      return n;
    }
    var r = n(15);
    e.exports = o;
  }, function (e, t, n) {
    "use strict";

    var o = n(21),
      r = n(22),
      i = n(20);
    e.exports = function () {
      function e(e, t, n, o, a, l) {
        l !== i && r(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = o, n.PropTypes = n, n;
    };
  }, function (e, t) {
    "use strict";

    var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    e.exports = n;
  }, function (e, t) {
    "use strict";

    function n(e) {
      return function () {
        return e;
      };
    }
    var o = function o() {};
    o.thatReturns = n, o.thatReturnsFalse = n(!1), o.thatReturnsTrue = n(!0), o.thatReturnsNull = n(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";

    function o(e, t, n, o, i, a, l, s) {
      if (r(t), !e) {
        var u;
        if (void 0 === t) u = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [n, o, i, a, l, s],
            f = 0;
          u = new Error(t.replace(/%s/g, function () {
            return c[f++];
          })), u.name = "Invariant Violation";
        }
        throw u.framesToPop = 1, u;
      }
    }
    var r = function r(e) {};
    e.exports = o;
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var n, o, r, i, a, l;
        "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : "undefined" != typeof t && null !== t && t.hrtime ? (e.exports = function () {
          return (n() - a) / 1e6;
        }, o = t.hrtime, n = function n() {
          var e;
          return e = o(), 1e9 * e[0] + e[1];
        }, i = n(), l = 1e9 * t.uptime(), a = i - l) : Date.now ? (e.exports = function () {
          return Date.now() - r;
        }, r = Date.now()) : (e.exports = function () {
          return new Date().getTime() - r;
        }, r = new Date().getTime());
      }).call(this);
    }).call(t, n(10));
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    t.__esModule = !0;
    var a = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }
        return e;
      },
      l = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }
        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
      s = n(6),
      u = o(s),
      c = n(3),
      f = o(c),
      p = n(8),
      d = o(p),
      h = n(4),
      y = o(h),
      v = n(5),
      m = o(v),
      b = n(7),
      S = o(b),
      g = n(1),
      w = o(g),
      P = n(2),
      T = o(P),
      k = 1e3 / 60,
      O = function (e) {
        function t(n) {
          var o = this;
          r(this, t), e.call(this, n), this.wasAnimating = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyle = null, this.clearUnreadPropStyle = function (e) {
            var t = !1,
              n = o.state,
              r = n.currentStyle,
              i = n.currentVelocity,
              l = n.lastIdealStyle,
              s = n.lastIdealVelocity;
            for (var u in e) {
              if (Object.prototype.hasOwnProperty.call(e, u)) {
                var c = e[u];
                "number" == typeof c && (t || (t = !0, r = a({}, r), i = a({}, i), l = a({}, l), s = a({}, s)), r[u] = c, i[u] = 0, l[u] = c, s[u] = 0);
              }
            }
            t && o.setState({
              currentStyle: r,
              currentVelocity: i,
              lastIdealStyle: l,
              lastIdealVelocity: s
            });
          }, this.startAnimationIfNecessary = function () {
            o.animationID = m.default(function (e) {
              var t = o.props.style;
              if (S.default(o.state.currentStyle, t, o.state.currentVelocity)) return o.wasAnimating && o.props.onRest && o.props.onRest(), o.animationID = null, o.wasAnimating = !1, void (o.accumulatedTime = 0);
              o.wasAnimating = !0;
              var n = e || y.default(),
                r = n - o.prevTime;
              if (o.prevTime = n, o.accumulatedTime = o.accumulatedTime + r, o.accumulatedTime > 10 * k && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();
              var i = (o.accumulatedTime - Math.floor(o.accumulatedTime / k) * k) / k,
                a = Math.floor(o.accumulatedTime / k),
                l = {},
                s = {},
                u = {},
                c = {};
              for (var f in t) {
                if (Object.prototype.hasOwnProperty.call(t, f)) {
                  var p = t[f];
                  if ("number" == typeof p) u[f] = p, c[f] = 0, l[f] = p, s[f] = 0;else {
                    for (var h = o.state.lastIdealStyle[f], v = o.state.lastIdealVelocity[f], m = 0; m < a; m++) {
                      var b = d.default(k / 1e3, h, v, p.val, p.stiffness, p.damping, p.precision);
                      h = b[0], v = b[1];
                    }
                    var g = d.default(k / 1e3, h, v, p.val, p.stiffness, p.damping, p.precision),
                      w = g[0],
                      P = g[1];
                    u[f] = h + (w - h) * i, c[f] = v + (P - v) * i, l[f] = h, s[f] = v;
                  }
                }
              }
              o.animationID = null, o.accumulatedTime -= a * k, o.setState({
                currentStyle: u,
                currentVelocity: c,
                lastIdealStyle: l,
                lastIdealVelocity: s
              }), o.unreadPropStyle = null, o.startAnimationIfNecessary();
            });
          }, this.state = this.defaultState();
        }
        return i(t, e), l(t, null, [{
          key: "propTypes",
          value: {
            defaultStyle: T.default.objectOf(T.default.number),
            style: T.default.objectOf(T.default.oneOfType([T.default.number, T.default.object])).isRequired,
            children: T.default.func.isRequired,
            onRest: T.default.func
          },
          enumerable: !0
        }]), t.prototype.defaultState = function () {
          var e = this.props,
            t = e.defaultStyle,
            n = e.style,
            o = t || f.default(n),
            r = u.default(o);
          return {
            currentStyle: o,
            currentVelocity: r,
            lastIdealStyle: o,
            lastIdealVelocity: r
          };
        }, t.prototype.componentDidMount = function () {
          this.prevTime = y.default(), this.startAnimationIfNecessary();
        }, t.prototype.componentWillReceiveProps = function (e) {
          null != this.unreadPropStyle && this.clearUnreadPropStyle(this.unreadPropStyle), this.unreadPropStyle = e.style, null == this.animationID && (this.prevTime = y.default(), this.startAnimationIfNecessary());
        }, t.prototype.componentWillUnmount = function () {
          null != this.animationID && (m.default.cancel(this.animationID), this.animationID = null);
        }, t.prototype.render = function () {
          var e = this.props.children(this.state.currentStyle);
          return e && w.default.Children.only(e);
        }, t;
      }(w.default.Component);
    t.default = O, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    function a(e, t, n) {
      for (var o = 0; o < e.length; o++) {
        if (!g.default(e[o], t[o], n[o])) return !1;
      }
      return !0;
    }
    t.__esModule = !0;
    var l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }
        return e;
      },
      s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }
        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
      u = n(6),
      c = o(u),
      f = n(3),
      p = o(f),
      d = n(8),
      h = o(d),
      y = n(4),
      v = o(y),
      m = n(5),
      b = o(m),
      S = n(7),
      g = o(S),
      w = n(1),
      P = o(w),
      T = n(2),
      k = o(T),
      O = 1e3 / 60,
      M = function (e) {
        function t(n) {
          var o = this;
          r(this, t), e.call(this, n), this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
            for (var t = o.state, n = t.currentStyles, r = t.currentVelocities, i = t.lastIdealStyles, a = t.lastIdealVelocities, s = !1, u = 0; u < e.length; u++) {
              var c = e[u],
                f = !1;
              for (var p in c) {
                if (Object.prototype.hasOwnProperty.call(c, p)) {
                  var d = c[p];
                  "number" == typeof d && (f || (f = !0, s = !0, n[u] = l({}, n[u]), r[u] = l({}, r[u]), i[u] = l({}, i[u]), a[u] = l({}, a[u])), n[u][p] = d, r[u][p] = 0, i[u][p] = d, a[u][p] = 0);
                }
              }
            }
            s && o.setState({
              currentStyles: n,
              currentVelocities: r,
              lastIdealStyles: i,
              lastIdealVelocities: a
            });
          }, this.startAnimationIfNecessary = function () {
            o.animationID = b.default(function (e) {
              var t = o.props.styles(o.state.lastIdealStyles);
              if (a(o.state.currentStyles, t, o.state.currentVelocities)) return o.animationID = null, void (o.accumulatedTime = 0);
              var n = e || v.default(),
                r = n - o.prevTime;
              if (o.prevTime = n, o.accumulatedTime = o.accumulatedTime + r, o.accumulatedTime > 10 * O && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();
              for (var i = (o.accumulatedTime - Math.floor(o.accumulatedTime / O) * O) / O, l = Math.floor(o.accumulatedTime / O), s = [], u = [], c = [], f = [], p = 0; p < t.length; p++) {
                var d = t[p],
                  y = {},
                  m = {},
                  b = {},
                  S = {};
                for (var g in d) {
                  if (Object.prototype.hasOwnProperty.call(d, g)) {
                    var w = d[g];
                    if ("number" == typeof w) y[g] = w, m[g] = 0, b[g] = w, S[g] = 0;else {
                      for (var P = o.state.lastIdealStyles[p][g], T = o.state.lastIdealVelocities[p][g], k = 0; k < l; k++) {
                        var M = h.default(O / 1e3, P, T, w.val, w.stiffness, w.damping, w.precision);
                        P = M[0], T = M[1];
                      }
                      var x = h.default(O / 1e3, P, T, w.val, w.stiffness, w.damping, w.precision),
                        I = x[0],
                        D = x[1];
                      y[g] = P + (I - P) * i, m[g] = T + (D - T) * i, b[g] = P, S[g] = T;
                    }
                  }
                }
                c[p] = y, f[p] = m, s[p] = b, u[p] = S;
              }
              o.animationID = null, o.accumulatedTime -= l * O, o.setState({
                currentStyles: c,
                currentVelocities: f,
                lastIdealStyles: s,
                lastIdealVelocities: u
              }), o.unreadPropStyles = null, o.startAnimationIfNecessary();
            });
          }, this.state = this.defaultState();
        }
        return i(t, e), s(t, null, [{
          key: "propTypes",
          value: {
            defaultStyles: k.default.arrayOf(k.default.objectOf(k.default.number)),
            styles: k.default.func.isRequired,
            children: k.default.func.isRequired
          },
          enumerable: !0
        }]), t.prototype.defaultState = function () {
          var e = this.props,
            t = e.defaultStyles,
            n = e.styles,
            o = t || n().map(p.default),
            r = o.map(function (e) {
              return c.default(e);
            });
          return {
            currentStyles: o,
            currentVelocities: r,
            lastIdealStyles: o,
            lastIdealVelocities: r
          };
        }, t.prototype.componentDidMount = function () {
          this.prevTime = v.default(), this.startAnimationIfNecessary();
        }, t.prototype.componentWillReceiveProps = function (e) {
          null != this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles), this.unreadPropStyles = e.styles(this.state.lastIdealStyles), null == this.animationID && (this.prevTime = v.default(), this.startAnimationIfNecessary());
        }, t.prototype.componentWillUnmount = function () {
          null != this.animationID && (b.default.cancel(this.animationID), this.animationID = null);
        }, t.prototype.render = function () {
          var e = this.props.children(this.state.currentStyles);
          return e && P.default.Children.only(e);
        }, t;
      }(P.default.Component);
    t.default = M, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    function a(e, t, n) {
      var o = t;
      return null == o ? e.map(function (e, t) {
        return {
          key: e.key,
          data: e.data,
          style: n[t]
        };
      }) : e.map(function (e, t) {
        for (var r = 0; r < o.length; r++) {
          if (o[r].key === e.key) return {
            key: o[r].key,
            data: o[r].data,
            style: n[t]
          };
        }
        return {
          key: e.key,
          data: e.data,
          style: n[t]
        };
      });
    }
    function l(e, t, n, o) {
      if (o.length !== t.length) return !1;
      for (var r = 0; r < o.length; r++) {
        if (o[r].key !== t[r].key) return !1;
      }
      for (var r = 0; r < o.length; r++) {
        if (!k.default(e[r], t[r].style, n[r])) return !1;
      }
      return !0;
    }
    function s(e, t, n, o, r, i, a, l, s) {
      for (var u = b.default(o, r, function (e, o) {
          var r = t(o);
          return null == r ? (n({
            key: o.key,
            data: o.data
          }), null) : k.default(i[e], r, a[e]) ? (n({
            key: o.key,
            data: o.data
          }), null) : {
            key: o.key,
            data: o.data,
            style: r
          };
        }), c = [], f = [], d = [], h = [], y = 0; y < u.length; y++) {
        for (var v = u[y], m = null, S = 0; S < o.length; S++) {
          if (o[S].key === v.key) {
            m = S;
            break;
          }
        }
        if (null == m) {
          var g = e(v);
          c[y] = g, d[y] = g;
          var w = p.default(v.style);
          f[y] = w, h[y] = w;
        } else c[y] = i[m], d[y] = l[m], f[y] = a[m], h[y] = s[m];
      }
      return [u, c, f, d, h];
    }
    t.__esModule = !0;
    var u = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }
        return e;
      },
      c = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }
        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
      f = n(6),
      p = o(f),
      d = n(3),
      h = o(d),
      y = n(8),
      v = o(y),
      m = n(27),
      b = o(m),
      S = n(4),
      g = o(S),
      w = n(5),
      P = o(w),
      T = n(7),
      k = o(T),
      O = n(1),
      M = o(O),
      x = n(2),
      I = o(x),
      D = 1e3 / 60,
      _ = function (e) {
        function t(n) {
          var o = this;
          r(this, t), e.call(this, n), this.unmounting = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
            for (var t = s(o.props.willEnter, o.props.willLeave, o.props.didLeave, o.state.mergedPropsStyles, e, o.state.currentStyles, o.state.currentVelocities, o.state.lastIdealStyles, o.state.lastIdealVelocities), n = t[0], r = t[1], i = t[2], a = t[3], l = t[4], c = 0; c < e.length; c++) {
              var f = e[c].style,
                p = !1;
              for (var d in f) {
                if (Object.prototype.hasOwnProperty.call(f, d)) {
                  var h = f[d];
                  "number" == typeof h && (p || (p = !0, r[c] = u({}, r[c]), i[c] = u({}, i[c]), a[c] = u({}, a[c]), l[c] = u({}, l[c]), n[c] = {
                    key: n[c].key,
                    data: n[c].data,
                    style: u({}, n[c].style)
                  }), r[c][d] = h, i[c][d] = 0, a[c][d] = h, l[c][d] = 0, n[c].style[d] = h);
                }
              }
            }
            o.setState({
              currentStyles: r,
              currentVelocities: i,
              mergedPropsStyles: n,
              lastIdealStyles: a,
              lastIdealVelocities: l
            });
          }, this.startAnimationIfNecessary = function () {
            o.unmounting || (o.animationID = P.default(function (e) {
              if (!o.unmounting) {
                var t = o.props.styles,
                  n = "function" == typeof t ? t(a(o.state.mergedPropsStyles, o.unreadPropStyles, o.state.lastIdealStyles)) : t;
                if (l(o.state.currentStyles, n, o.state.currentVelocities, o.state.mergedPropsStyles)) return o.animationID = null, void (o.accumulatedTime = 0);
                var r = e || g.default(),
                  i = r - o.prevTime;
                if (o.prevTime = r, o.accumulatedTime = o.accumulatedTime + i, o.accumulatedTime > 10 * D && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();
                for (var u = (o.accumulatedTime - Math.floor(o.accumulatedTime / D) * D) / D, c = Math.floor(o.accumulatedTime / D), f = s(o.props.willEnter, o.props.willLeave, o.props.didLeave, o.state.mergedPropsStyles, n, o.state.currentStyles, o.state.currentVelocities, o.state.lastIdealStyles, o.state.lastIdealVelocities), p = f[0], d = f[1], h = f[2], y = f[3], m = f[4], b = 0; b < p.length; b++) {
                  var S = p[b].style,
                    w = {},
                    P = {},
                    T = {},
                    k = {};
                  for (var O in S) {
                    if (Object.prototype.hasOwnProperty.call(S, O)) {
                      var M = S[O];
                      if ("number" == typeof M) w[O] = M, P[O] = 0, T[O] = M, k[O] = 0;else {
                        for (var x = y[b][O], I = m[b][O], _ = 0; _ < c; _++) {
                          var j = v.default(D / 1e3, x, I, M.val, M.stiffness, M.damping, M.precision);
                          x = j[0], I = j[1];
                        }
                        var C = v.default(D / 1e3, x, I, M.val, M.stiffness, M.damping, M.precision),
                          z = C[0],
                          E = C[1];
                        w[O] = x + (z - x) * u, P[O] = I + (E - I) * u, T[O] = x, k[O] = I;
                      }
                    }
                  }
                  y[b] = T, m[b] = k, d[b] = w, h[b] = P;
                }
                o.animationID = null, o.accumulatedTime -= c * D, o.setState({
                  currentStyles: d,
                  currentVelocities: h,
                  lastIdealStyles: y,
                  lastIdealVelocities: m,
                  mergedPropsStyles: p
                }), o.unreadPropStyles = null, o.startAnimationIfNecessary();
              }
            }));
          }, this.state = this.defaultState();
        }
        return i(t, e), c(t, null, [{
          key: "propTypes",
          value: {
            defaultStyles: I.default.arrayOf(I.default.shape({
              key: I.default.string.isRequired,
              data: I.default.any,
              style: I.default.objectOf(I.default.number).isRequired
            })),
            styles: I.default.oneOfType([I.default.func, I.default.arrayOf(I.default.shape({
              key: I.default.string.isRequired,
              data: I.default.any,
              style: I.default.objectOf(I.default.oneOfType([I.default.number, I.default.object])).isRequired
            }))]).isRequired,
            children: I.default.func.isRequired,
            willEnter: I.default.func,
            willLeave: I.default.func,
            didLeave: I.default.func
          },
          enumerable: !0
        }, {
          key: "defaultProps",
          value: {
            willEnter: function willEnter(e) {
              return h.default(e.style);
            },
            willLeave: function willLeave() {
              return null;
            },
            didLeave: function didLeave() {}
          },
          enumerable: !0
        }]), t.prototype.defaultState = function () {
          var e = this.props,
            t = e.defaultStyles,
            n = e.styles,
            o = e.willEnter,
            r = e.willLeave,
            i = e.didLeave,
            a = "function" == typeof n ? n(t) : n,
            l = void 0;
          l = null == t ? a : t.map(function (e) {
            for (var t = 0; t < a.length; t++) {
              if (a[t].key === e.key) return a[t];
            }
            return e;
          });
          var u = null == t ? a.map(function (e) {
              return h.default(e.style);
            }) : t.map(function (e) {
              return h.default(e.style);
            }),
            c = null == t ? a.map(function (e) {
              return p.default(e.style);
            }) : t.map(function (e) {
              return p.default(e.style);
            }),
            f = s(o, r, i, l, a, u, c, u, c),
            d = f[0],
            y = f[1],
            v = f[2],
            m = f[3],
            b = f[4];
          return {
            currentStyles: y,
            currentVelocities: v,
            lastIdealStyles: m,
            lastIdealVelocities: b,
            mergedPropsStyles: d
          };
        }, t.prototype.componentDidMount = function () {
          this.prevTime = g.default(), this.startAnimationIfNecessary();
        }, t.prototype.componentWillReceiveProps = function (e) {
          this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles);
          var t = e.styles;
          "function" == typeof t ? this.unreadPropStyles = t(a(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles)) : this.unreadPropStyles = t, null == this.animationID && (this.prevTime = g.default(), this.startAnimationIfNecessary());
        }, t.prototype.componentWillUnmount = function () {
          this.unmounting = !0, null != this.animationID && (P.default.cancel(this.animationID), this.animationID = null);
        }, t.prototype.render = function () {
          var e = a(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles),
            t = this.props.children(e);
          return t && M.default.Children.only(t);
        }, t;
      }(M.default.Component);
    t.default = _, e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function n(e, t, n) {
      for (var o = {}, r = 0; r < e.length; r++) {
        o[e[r].key] = r;
      }
      for (var i = {}, r = 0; r < t.length; r++) {
        i[t[r].key] = r;
      }
      for (var a = [], r = 0; r < t.length; r++) {
        a[r] = t[r];
      }
      for (var r = 0; r < e.length; r++) {
        if (!Object.prototype.hasOwnProperty.call(i, e[r].key)) {
          var l = n(r, e[r]);
          null != l && a.push(l);
        }
      }
      return a.sort(function (e, n) {
        var r = i[e.key],
          a = i[n.key],
          l = o[e.key],
          s = o[n.key];
        if (null != r && null != a) return i[e.key] - i[n.key];
        if (null != l && null != s) return o[e.key] - o[n.key];
        if (null != r) {
          for (var u = 0; u < t.length; u++) {
            var c = t[u].key;
            if (Object.prototype.hasOwnProperty.call(o, c)) {
              if (r < i[c] && s > o[c]) return -1;
              if (r > i[c] && s < o[c]) return 1;
            }
          }
          return 1;
        }
        for (var u = 0; u < t.length; u++) {
          var c = t[u].key;
          if (Object.prototype.hasOwnProperty.call(o, c)) {
            if (a < i[c] && l > o[c]) return 1;
            if (a > i[c] && l < o[c]) return -1;
          }
        }
        return -1;
      });
    }
    t.__esModule = !0, t.default = n, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function o() {}
    t.__esModule = !0, t.default = o;
    e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e, t) {
      return i({}, s, t, {
        val: e
      });
    }
    t.__esModule = !0;
    var i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }
      return e;
    };
    t.default = r;
    var a = n(11),
      l = o(a),
      s = i({}, l.default.noWobble, {
        precision: .01
      });
    e.exports = t.default;
  }, function (e, t, n) {
    function o(e, t) {
      for (var n = 0; n < e.length; n++) {
        var o = e[n],
          r = d[o.id];
        if (r) {
          r.refs++;
          for (var i = 0; i < r.parts.length; i++) {
            r.parts[i](o.parts[i]);
          }
          for (; i < o.parts.length; i++) {
            r.parts.push(u(o.parts[i], t));
          }
        } else {
          for (var a = [], i = 0; i < o.parts.length; i++) {
            a.push(u(o.parts[i], t));
          }
          d[o.id] = {
            id: o.id,
            refs: 1,
            parts: a
          };
        }
      }
    }
    function r(e) {
      for (var t = [], n = {}, o = 0; o < e.length; o++) {
        var r = e[o],
          i = r[0],
          a = r[1],
          l = r[2],
          s = r[3],
          u = {
            css: a,
            media: l,
            sourceMap: s
          };
        n[i] ? n[i].parts.push(u) : t.push(n[i] = {
          id: i,
          parts: [u]
        });
      }
      return t;
    }
    function i(e, t) {
      var n = v(),
        o = S[S.length - 1];
      if ("top" === e.insertAt) o ? o.nextSibling ? n.insertBefore(t, o.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), S.push(t);else {
        if ("bottom" !== e.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
        n.appendChild(t);
      }
    }
    function a(e) {
      e.parentNode.removeChild(e);
      var t = S.indexOf(e);
      t >= 0 && S.splice(t, 1);
    }
    function l(e) {
      var t = document.createElement("style");
      return t.type = "text/css", i(e, t), t;
    }
    function s(e) {
      var t = document.createElement("link");
      return t.rel = "stylesheet", i(e, t), t;
    }
    function u(e, t) {
      var n, o, r;
      if (t.singleton) {
        var i = b++;
        n = m || (m = l(t)), o = c.bind(null, n, i, !1), r = c.bind(null, n, i, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = s(t), o = p.bind(null, n), r = function r() {
        a(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = l(t), o = f.bind(null, n), r = function r() {
        a(n);
      });
      return o(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          o(e = t);
        } else r();
      };
    }
    function c(e, t, n, o) {
      var r = n ? "" : o.css;
      if (e.styleSheet) e.styleSheet.cssText = g(t, r);else {
        var i = document.createTextNode(r),
          a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
      }
    }
    function f(e, t) {
      var n = t.css,
        o = t.media;
      if (o && e.setAttribute("media", o), e.styleSheet) e.styleSheet.cssText = n;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }
        e.appendChild(document.createTextNode(n));
      }
    }
    function p(e, t) {
      var n = t.css,
        o = t.sourceMap;
      o && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var r = new Blob([n], {
          type: "text/css"
        }),
        i = e.href;
      e.href = URL.createObjectURL(r), i && URL.revokeObjectURL(i);
    }
    var d = {},
      h = function h(e) {
        var t;
        return function () {
          return "undefined" == typeof t && (t = e.apply(this, arguments)), t;
        };
      },
      y = h(function () {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
      }),
      v = h(function () {
        return document.head || document.getElementsByTagName("head")[0];
      }),
      m = null,
      b = 0,
      S = [];
    e.exports = function (e, t) {
      t = t || {}, "undefined" == typeof t.singleton && (t.singleton = y()), "undefined" == typeof t.insertAt && (t.insertAt = "bottom");
      var n = r(e);
      return o(n, t), function (e) {
        for (var i = [], a = 0; a < n.length; a++) {
          var l = n[a],
            s = d[l.id];
          s.refs--, i.push(s);
        }
        if (e) {
          var u = r(e);
          o(u, t);
        }
        for (var a = 0; a < i.length; a++) {
          var s = i[a];
          if (0 === s.refs) {
            for (var c = 0; c < s.parts.length; c++) {
              s.parts[c]();
            }
            delete d[s.id];
          }
        }
      };
    };
    var g = function () {
      var e = [];
      return function (t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();
  }, function (e, t, n) {
    var o = n(16);
    "string" == typeof o && (o = [[e.id, o, ""]]);
    n(30)(o, {});
    o.locals && (e.exports = o.locals);
  }]);
});